<template>
  <div>
    <VuePerfectScrollbar
      class="gm-list-selection-grid"
      :style="{
        height: templatesHeight,
      }"
    >
      <div
        v-if="gridView"
        class="
          px-2 sm:px-4
          gap-y-10 gap-x-6
          grid 
          sm:grid-cols-1
          md:grid-cols-3
          lg:grid-cols-4
          xl:gap-x-6
        "
      >
        <div v-for="template in templates" class="mb-4" :key="template.id">
          <div class="w-full rounded-lg h-400 relative">
            <div
              class="
                absolute
                w-full
                h-400
                rounded-lg
                opacity-0
                hover:opacity-100
                flex
                items-center
                justify-center
                flex-col
                gap-4
              "
              style="background-color: rgba(0, 0, 0, 0.6)"
            >
              <gd-button
                v-if="template.thumbnail"
                size="auto"
                class="
                  h-10
                  btn-width
                  px-2
                  btn-radius
                  text-base
                  font-semibold
                  border-grey-300
                "
                @click="previewTemplate(template)"
                >{{ $t('frontend_preview') }}</gd-button
              >
              <gd-button
                variant="primary"
                size="auto"
                class="
                  h-10
                  btn-width
                  px-4
                  btn-radius
                  text-base
                  font-semibold
                "
                @click="selectTemplate(template)"
              >
                {{ $t('frontend_select') }}</gd-button
              >
            </div>

            <div
              v-if="template.thumbnail"
              class="w-full h-400 rounded-lg bg-cover text-center"
              :style="{
                backgroundImage: `url(${template.thumbnail})`,
                backgroundPosition: `center top`,
              }"
            ></div>
            <div v-else>
              <div
                class="
                  w-full
                  h-400
                  bg-white
                  rounded-lg
                  flex flex-col
                  items-center
                  justify-center
                  text-grey-300 text-3xl
                  font-bold
                  cursor-pointer
                "
              >
                <div>{{ $t('frontend_sites_create_site_blank') }}</div>
                <div>{{ $t('frontend_sites_create_site_template') }}</div>
              </div>
            </div>
          </div>
          <div class="mt-3">
            <p class="font-bold text-grey-900">{{ template.name }}</p>
          </div>
        </div>
      </div>

      <div
        v-if="!gridView"
        class="px-4 grid grid-cols-2 gap-4 sm:grid-cols-3 xl:gap-8"
      >
        <info-panel
          v-for="template in templates"
          :key="template.id"
          class="w-auto"
        >
          <template slot="content">
            <div class="w-full h-full rounded-t-lg relative">
              <div  v-if="template.thumbnail "
                class="
                  absolute
                  w-full
                  h-full
                  rounded-t-lg
                  bg-grey-transparent
                  opacity-0
                  hover:opacity-100
                  flex
                  items-center
                  justify-center
                "
              >
                <gd-button
                  variant="primary"
                  size="lg"
                  @click="editTemplate(template)"
                  >{{
                    $t(
                      'frontend_groovemail_my_templates_edit_template'
                    )
                  }}</gd-button
                >
              </div>
              <div v-else
              class="
                  absolute
                  w-full
                  h-full
                  rounded-t-lg
                  bg-grey-transparent
                  opacity-0
                  hover:opacity-100
                  flex
                  items-center
                  justify-center
                "
              >
                <gd-button
                  variant="primary"
                  size="lg"
                  @click="selectTemplate(template)"
                  >{{
                    $t(
                      'frontend_groovemail_admin_global_templates_create_template'
                    )
                  }}</gd-button
                >
              </div>
              <screenshot
                v-if="template.thumbnail"
                class="w-full h-full rounded-t-lg bg-center blog-screenshot"
                :src="template.thumbnail"
              />
              <div class="h-full" v-else>
                <div
                  class="
                    w-full
                    h-full
                    bg-white
                    rounded-lg
                    flex flex-col
                    items-center
                    justify-center
                    text-grey-300 text-3xl
                    font-bold
                    cursor-pointer
                  "
                >
                  <div>{{ $t('frontend_sites_create_site_blank') }}</div>
                  <div>{{ $t('frontend_sites_create_site_template') }}</div>
                </div>
              </div>
            </div>
          </template>
          <template slot="footer">
            <div class="flex justify-between px-4 w-full">
              <div class="flex flex-col justify-center">
                <div class="font-semibold">{{ template.name }}</div>
                <div
                  class="text-sm text-grey-600 mt-1"
                  v-if="template.thumbnail"
                >
                  {{ $t('frontend_resources_index_created_at') }}:
                  {{
                    template.created_at
                      ? `${new Date(template.created_at).getDate()} ${
                          months[new Date(template.created_at).getMonth()]
                        }, ${new Date(template.created_at).getFullYear()}`
                      : $t('frontend_groovemail_not_available')
                  }}
                </div>
              </div>
              <drop-menu
                v-if="template.thumbnail"
                class="template-dropmenu"
                :menu-items="getMenuItems(template)"
                small
              ></drop-menu>
            </div>
          </template>
        </info-panel>
      </div>

      <infinite-loading
        ref="infinteTemplateLoader"
        spinner="spiral"
        @infinite="infiniteHandler"
      >
        <div class="text-sm text-primary-dark" slot="no-more">
          <p v-if="templates && templates.length" class="pb-4"></p>
          <p v-else class="pb-4"></p>
        </div>
        <div class="text-sm text-primary-dark" slot="no-results">
          <p v-if="templates && templates.length" class="pb-4"></p>
          <p v-else class="pb-4"></p>
        </div>
      </infinite-loading>
    </VuePerfectScrollbar>

    <gd-modal
      ref="modal"
      name="previewModal"
      bgType="black"
      height="93vh"
      class="w-11/12 md:w-2/3 xl:w-2/4 m-auto overflow-hidden"
      :title="$t('frontend_preview')"
    >
      <div class="relative w-full h-full overflow-hidden">
        <VuePerfectScrollbar class="w-full h-full overflow-auto">
          <img class="w-full" :src="selectedTemplateImage" />
        </VuePerfectScrollbar>
      </div>
    </gd-modal>
  </div>
</template>

<script>
import Auth from '@groovepages/gd-lib/auth';
import axios from 'axios';
import InfiniteLoading from 'vue-infinite-loading';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import CloseIcon from '../assets/close-icon.svg';
import GdModal from './Modal';

import DropMenu from './DropMenu';
import InfoPanel from './InfoPanel';
import Screenshot from './Screenshot';

export default {
  name: 'TemplatesList',
  components: {
    GdModal,
    CloseIcon,
    VuePerfectScrollbar,
    InfiniteLoading,
    InfoPanel,
    DropMenu,
    Screenshot,
  },

  props: {
    url: {
      required: false,
    },
    search: {
      required: false,
    },
    filters: {
      required: false,
    },
    showOnlyGlobal: {
      required: false,
    },
    templatesHeight: {
      required: false,
      default: 'calc(100vh - 120px)',
    },
    gridView: {
      required: false,
      default: true,
    },
  },

  watch: {
    async search() {
      this.page = 1;
      this.templates = [];
      this.$refs.infinteTemplateLoader.stateChanger.reset();
      // await this.infiniteHandler(this.$refs.infinteTemplateLoader.stateChanger);
    },

    async 'filters.total'() {
      this.page = 1;
      this.templates = [];
      this.$refs.infinteTemplateLoader.stateChanger.reset();
      // await this.infiniteHandler(this.$refs.infinteTemplateLoader.stateChanger);
    },
  },

  computed: {
    months() {
      return [
        this.$t('frontend_groovemail_month_jan_short'),
        this.$t('frontend_groovemail_month_feb_short'),
        this.$t('frontend_groovemail_month_mar_short'),
        this.$t('frontend_groovemail_month_apr_short'),
        this.$t('frontend_groovemail_month_may_short'),
        this.$t('frontend_groovemail_month_jun_short'),
        this.$t('frontend_groovemail_month_jul_short'),
        this.$t('frontend_groovemail_month_aug_short'),
        this.$t('frontend_groovemail_month_sep_short'),
        this.$t('frontend_groovemail_month_oct_short'),
        this.$t('frontend_groovemail_month_nov_short'),
        this.$t('frontend_groovemail_month_dec_short'),
      ];
    },
  },

  data() {
    return {
      selectedTemplateImage: '',
      templates: [],
      page: 1,
      limit: 10,
      lastPage: 0,
      blank_template: {
        id: 'blank_template_001',
        name: this.$t(
          'frontend_groovemail_befree_email_builder_blank_template_name'
        ),
      },
    };
  },

  async created() {
    await this.initializeTemplates();
  },

  methods: {
    async initializeTemplates() {
      let blankTemplatePresent = this.templates.find(
        (ele) => ele.id === 'blank_template_001'
      );
      if (!blankTemplatePresent) {
        this.templates.push(this.blank_template);
      }
    },

    previewTemplate(template) {
      this.selectedTemplateImage = template.preview_image;
      this.$root.$emit('modal-open', 'previewModal');
    },

    selectTemplate(template) {
      this.$emit('selectedTemplate', template.id);
    },

    editTemplate(template) {
      if(template.is_global){
        this.$emit('selectedTemplate', template.id);
      }
      else{
      this.$emit('editTemplate', template.id);
      }
    },
    
    closePreview() {
      this.$root.$emit('modal-close', 'previewModal');
    },

    fetchTemplates() {
      const { token } = Auth.authenticatedUser();
      let url = `${this.url}?page=${this.page}&limit=${this.limit}`;
      if (this.search) {
        url += `&search=${this.search}`;
      }
      if (this.filters) {
        if (this.filters.categories && this.filters.categories.length) {
          url += `&category_ids=${this.filters.categories}`;
        }
        if (this.filters.usages && this.filters.usages.length) {
          url += `&usage_ids=${this.filters.usages}`;
        }
        if (
          this.filters.automated_types &&
          this.filters.automated_types.length
        ) {
          url += `&automated_ids=${this.filters.automated_types}`;
        }
        if (this.filters.seasons && this.filters.seasons.length) {
          url += `&seasons_ids=${this.filters.seasons}`;
        }
      }
      return axios.get(url, {
        headers: {
          Authorization: 'Bearer ' + token, //the token is a variable which holds the token
        },
      });
    },

    async infiniteHandler($state) {
      try {
        const response = await this.fetchTemplates();
        await this.initializeTemplates();
        if (response.data && response.data.data && response.data.data.length) {
          this.addFetchedTemplates(response.data);
          if (this.page - 1 === this.lastPage) {
            this.page = 2;
            $state.complete();
          } else {
            this.page += 1;
          }
          $state.loaded();
        } else {
          $state.complete();
        }
      } catch (e) {
        console.log(e);
      }
    },

    async addFetchedTemplates(templatesData) {
      this.lastPage = templatesData.last_page;
      templatesData.data.forEach((template) => {
        const templateExisting = this.templates.find(
          (ele) => ele.id === template.id
        );
        if (!templateExisting) {
          this.templates.push(template);
        }
      });
    },

    getMenuItems(selectedTemplate) {
      const items = [];
      if (!selectedTemplate.is_global) {
        items.push({
          text: this.$t('frontend_edit'),
          callback: () => {
            this.$emit('editTemplate', selectedTemplate.id);
          },
        });

        items.push({
          text: this.$t('frontend_rename'),
          callback: () => {
            this.$emit('renameTemplate', selectedTemplate.id);
          },
        });
        
        items.push({
          text: this.$t('frontend_clone'),
          callback: () => {
            this.$emit('cloneTemplate', selectedTemplate);
          },
        });
        items.push({
          text: this.$t('frontend_delete'),
          callback: () => {
            this.$emit('deleteTemplate', selectedTemplate.id);
          },
        });
      }
      items.push({
        text: this.$t('frontend_preview'),
        callback: () => {
          this.previewTemplate(selectedTemplate);
        },
      });
      return items;
    },
  },
};
</script>

<style lang="scss">
.gm-list-selection-grid {
  overflow: scroll;
  .h-400 {
    height: 400px;
  }
  @media (min-width: 1600px) {
    .h-400 {
      height: 550px;
    }
  }
  @media (min-width: 2000px) {
    .h-400 {
      height: 650px;
    }
  }
}
</style>
